import type { CMYK, RGB } from "pdf-lib"
import { cmyk, rgb } from "pdf-lib"

import type { Color } from "../types/colors/Color"
import { ToRgb } from "./ToRgb"

/**
 * Converts a Color to a PDFLib color format
 * Preserves the original color space:
 * - RGB colors are converted to PDFLib RGB format (array of 3 values)
 * - CMYK colors are converted to PDFLib CMYK format (array of 4 values)
 * - HSL colors are converted to PDFLib RGB format (array of 3 values)
 *
 * All color formats are already in 0-1 range
 */
export const ToPdflibColor = (color: Color): CMYK | RGB => {
  if ("r" in color) {
    // It's an RGBColor, use PDFLib rgb function
    return rgb(color.r, color.g, color.b)
  } else if ("c" in color) {
    // It's a CMYKColor, use PDFLib cmyk function
    return cmyk(color.c, color.m, color.y, color.k)
  } else {
    // It's an HSLColor, convert to RGB first
    const c = ToRgb(color)
    return rgb(c.r, c.g, c.b)
  }
}
